import { useCallback, useMemo } from 'react';

import { useTypedDispatch, useTypedSelector } from 'store';

import { IPairConfig, setPairConfig } from '..';

interface IUsePairConfigProps {
  id?: number;
}

const usePairConfig = ({ id }: IUsePairConfigProps) => {
  const dispatch = useTypedDispatch();

  const pairConfig = useTypedSelector(store => store.pairConfigs.configs[id ?? 0]);

  const handleSetPairConfig = useCallback(
    (id: number, config: IPairConfig) => {
      dispatch(setPairConfig({ id, config }));
    },
    [dispatch],
  );

  const value = useMemo(
    () => ({ pairConfig: pairConfig ?? {}, setPairConfig: handleSetPairConfig }),
    [pairConfig, handleSetPairConfig],
  );

  return value;
};

export default usePairConfig;
